import { z } from "zod";

const route = z.object({
  distanceMetres: z.number(),
  durationSeconds: z.number(),
  provider: z.string(),
  calculatedAt: z.string(),
  trafficMode: z.string(),
});
const weather = z.object({
  availability: z.enum([
    "available",
    "unavailable",
    "stale",
    "not_requested",
    "failed",
  ]),
  condition: z.string().nullable(),
  temperatureCelsius: z.number().nullable(),
  precipitationProbability: z.number().nullable(),
  sourceTimestamp: z.string().nullable(),
  requiresRefresh: z.boolean(),
});
const stage = z.object({
  id: z.string(),
  stage: z.number(),
  category: z.string(),
  activityOfferingId: z.string().nullable(),
  branchId: z.string().nullable(),
  offeringName: z.string().nullable(),
  venueName: z.string().nullable(),
  branchName: z.string().nullable(),
  address: z.string().nullable(),
  startsAt: z.string(),
  endsAt: z.string(),
  estimatedPerPersonCostMinor: z.number(),
  bookingMode: z.enum([
    "walk_in",
    "no_booking_required",
    "request_to_book",
    "instant_book",
    "external_booking",
    "redacted",
  ]),
  reservationRequired: z.boolean(),
  depositRequired: z.boolean(),
  route: route.nullable(),
  weatherDecision: z.enum(["suitable", "caution", "unknown", "redacted"]),
  reason: z.string(),
  isRedacted: z.boolean(),
  featured: z.boolean(),
  featuredLabel: z.string().nullable(),
  image: z.string().optional(),
  minimumAge: z.number().optional(),
  removed: z.boolean().optional(),
  rowVersion: z.number().default(1),
});
export const planResultSchema = z.object({
  requestId: z.string(),
  plans: z
    .array(
      z.object({
        id: z.string(),
        alternative: z.number(),
        startsAt: z.string(),
        endsAt: z.string(),
        estimatedPerPersonCostMinor: z.number(),
        estimatedPartyCostMinor: z.number(),
        totalRouteDistanceMetres: z.number(),
        totalRouteDurationSeconds: z.number(),
        weather,
        reason: z.string(),
        featured: z.boolean(),
        featuredLabel: z.string().nullable(),
        stages: z.array(stage).min(1).max(5),
      }),
    )
    .min(1)
    .max(5),
});
export const tokensSchema = z.object({
  accessToken: z.string(),
  refreshToken: z.string(),
  accessExpiresAt: z.string(),
});
export const venuePageSchema = z.object({
  data: z.array(
    z.object({
      id: z.string(),
      venueName: z.string(),
      branchName: z.string(),
      address: z.string(),
      latitude: z.number(),
      longitude: z.number(),
      priceBand: z.number().min(1).max(4),
      activityCategories: z.array(z.string()),
      bookingModes: z.array(z.string()),
      hasRequestToBook: z.boolean(),
    }),
  ),
  total: z.number(),
  page: z.number(),
  pageSize: z.number(),
});
